import React from 'react';
import set from 'lodash/set';
import { Card } from '../../';
import { Controller, isArrayItem, } from '../../../../core';
import { useErrorChecker, useOneOf } from '../../../hooks';
import { Row } from '../../Layouts';
import { RemoveButton } from '../../RemoveButton';
export const CardOneOf = (props) => {
    var _a;
    const { input, meta, spec, name } = props;
    const [open, setOpen] = React.useState(true);
    const onToggle = React.useCallback(() => setOpen((f) => !f), [setOpen]);
    const onOpen = React.useCallback(() => setOpen(true), [setOpen]);
    const { oneOfValue, specProperties, togglerInput } = useOneOf({
        props,
        onTogglerChange: onOpen,
    });
    const toggler = React.useMemo(() => (React.createElement(Row, Object.assign({}, props, { name: "__stub-name" }), togglerInput)), [togglerInput, props]);
    const actions = React.useMemo(() => {
        if (isArrayItem(name)) {
            return React.createElement(RemoveButton, { onDrop: input.onDrop, name: name });
        }
        return;
    }, [name, input.onDrop]);
    const parentOnChange = React.useCallback((childName, childValue, childErrors) => {
        const value = set({}, childName.split(`${input.name}.`).join(''), childValue);
        input.onChange(value, childErrors);
    }, [input.onChange, input.name]);
    useErrorChecker({ name, meta, open, setOpen });
    return (React.createElement(Card, { name: name, title: toggler, description: spec.viewSpec.layoutDescription, actions: actions, open: open, onToggle: onToggle, disableHeaderToggle: true }, specProperties[oneOfValue] ? (React.createElement(Controller, { value: (_a = input.value) === null || _a === void 0 ? void 0 : _a[oneOfValue], spec: specProperties[oneOfValue], name: `${name}.${oneOfValue}`, parentOnChange: parentOnChange, parentOnUnmount: input.parentOnUnmount, key: `${name}.${oneOfValue}` })) : null));
};
